import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '../ui/input';

/**
 * Input mot de passe avec bouton œil pour afficher/masquer.
 * API : mêmes props que <Input> (value, onChange, placeholder, className, etc.).
 *
 *   <PasswordInput
 *     value={password}
 *     onChange={(e) => setPassword(e.target.value)}
 *     placeholder="••••••••"
 *     data-testid="login-password-input"
 *   />
 *
 * Le bouton œil est positionné en absolute à droite — le wrapper est en
 * relative pour le contenir. Si l'input a déjà une icône à gauche (ex: Lock),
 * passer la classe `pl-10` via `className` comme avant.
 */
export const PasswordInput = React.forwardRef(({ className = '', ...props }, ref) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative w-full">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#2E7D32]/40 rounded transition-colors"
        aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        aria-pressed={visible}
        tabIndex={0}
        data-testid="password-toggle-visibility"
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
